module.exports = __webpack_public_path__ + "img/delivery1.f8619511.png";